
import Vue from 'vue'
import { authAxios } from '../utils'
import { Component } from 'vue-property-decorator'
import CodeInput from '../../global/components/CodeInput.vue'

@Component({
  components: { CodeInput }
})
export default class TwoFactorSetup extends Vue {
  qrData: string | null = null

  error: string | null = null

  isLoading = false

  showSetupKey = false
  
  secretSetupKey: string | null = null

  get codeInput() {
    return this.$refs.field as CodeInput
  }

  async mounted() {
    const response = await authAxios.get<{ qrData: string, secret: string }>('/mfa/setup')
    this.qrData = response.data.qrData
    this.secretSetupKey = response.data.secret
  }

  async onComplete(code: string) {
      this.isLoading = true
      this.error = null
      try {
        await authAxios.post('/mfa/setup', { token: code })
        this.$store.dispatch('success', 'Authenticated successfully')
        this.$emit('success')
      } catch {
        this.error = 'Submission failed. Please double-check your code and try again.'
        this.codeInput.reset()
      } finally {
        this.isLoading = false
      }
    }
}
